import { Component, OnInit } from '@angular/core';
import { getLocalTranslate } from 'src/app/helpers/global-functions'

@Component({
  selector: 'app-become-instructor',
  templateUrl: './become-instructor.component.html',
  styleUrls: ['./become-instructor.component.css']
})
export class BecomeInstructorComponent implements OnInit {

  becomeInstructor:string = 'Become an Instructor'
  becomeInstructorDesc:string = ''
  becomePartner:string = 'Become a Partner'
  becomeParterDesc:string = ''
  contactUs:string = 'Contact Us'
  applyNow:string = 'Apply Now'

  constructor() { }

  ngOnInit(): void {
    this.needTranslate()
  }

  needTranslate(){
    this.becomeInstructor = getLocalTranslate('become-an-instructor',this.becomeInstructor)
    this.becomeInstructorDesc = getLocalTranslate('become-an-instructor-description',this.becomeInstructorDesc)
    this.becomePartner = getLocalTranslate('become-partner',this.becomePartner)
    this.becomeParterDesc = getLocalTranslate('become-partner-description',this.becomeParterDesc)
    this.contactUs = getLocalTranslate('contact-us',this.contactUs)
    this.applyNow = getLocalTranslate('apply-now',this.applyNow)
  }

}
